document.addEventListener('DOMContentLoaded', function() {
  let form, fileInput, fileNameDisplay, submitBtn, successMessage, progressBar, progressText, progressContainer, designUrlInput;
  
  // Override any global form validation
  window.addEventListener('error', function(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }, true);
  
  // Disable Shopify's form validation and any theme validation
  if (window.Shopify && window.Shopify.theme) {
    window.Shopify.theme.validateForm = function() { return true; };
  }
  
  // Override common validation functions
  window.alert = function() { return true; };
  window.confirm = function() { return true; };
  
  // Prevent any form validation popups
  document.addEventListener('invalid', function(e) {
    e.preventDefault();
    e.stopPropagation();
  }, true);

  // --- Configuration ---
  const CLOUDINARY_CLOUD_NAME = 'dix1lcuzl';
  const CLOUDINARY_UPLOAD_PRESET = 'shopify_design_contest';
  const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyBDy2RmFRcM5xJvbiT7B3eBP5Ts28Ti2-qGAvTGRqMZQ361Y9MRVhaY5u-ns0Tle50/exec';

  // --- Functions ---

  /**
   * Updates the progress bar UI.
   * @param {number} percent - The percentage of completion (0-100).
   */
  function updateProgress(percent) {
    const p = Math.round(percent);
    if (progressBar) progressBar.style.width = `${p}%`;
    if (progressText) progressText.textContent = `${p}%`;
  }

  /**
   * Handles the file upload to Cloudinary.
   * @param {File} file - The file to upload.
   * @param {function} callback - A function to call on successful upload.
   */
  function uploadFile(file, callback) {
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

    // Reset UI
    if (submitBtn) submitBtn.disabled = true;
    if (progressContainer) progressContainer.style.display = 'flex';
    updateProgress(0);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);

    xhr.upload.onprogress = function(e) {
      if (e.lengthComputable) {
        const percentComplete = (e.loaded / e.total) * 100;
        updateProgress(percentComplete);
      }
    };

    xhr.onload = function() {
      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        const uploadedUrl = response.secure_url;
        console.log('File uploaded successfully:', uploadedUrl);
        updateProgress(100);
        if (callback) {
          callback(uploadedUrl);
        }
      } else {
        console.error('Upload failed:', xhr.responseText);
        alert('Tiedoston lataus epäonnistui. Yritä uudelleen.');
        if (progressContainer) progressContainer.style.display = 'none';
        if (submitBtn) submitBtn.disabled = true;
      }
    };

    xhr.onerror = function() {
      console.error('An error occurred during the upload.');
      alert('Tiedoston lataus epäonnistui. Tarkista verkkoyhteytesi.');
      if (progressContainer) progressContainer.style.display = 'none';
      if (submitBtn) submitBtn.disabled = true;
    };

    xhr.send(formData);
  }

  /**
   * Handles the file input change event.
   */
  function onFileSelected(event) {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file size
    if (file.size > 5 * 1024 * 1024) { // 5MB
      alert('Tiedoston koko saa olla enintään 5MB.');
      fileInput.value = ''; // Reset file input
      if (fileNameDisplay) fileNameDisplay.textContent = '';
      return;
    }

    if (fileNameDisplay) fileNameDisplay.textContent = file.name;
    if (submitBtn) submitBtn.disabled = false; // Enable submit button once file is selected
  }

  /**
   * Handles form submission to Google Apps Script.
   */
  function onFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const file = fileInput.files[0];
    const name = form.querySelector('#name').value;
    const email = form.querySelector('#email').value;

    // --- Validation ---
    if (!file) {
      alert('Valitse suunnittelutiedosto.');
      return;
    }
    if (!name || !email) {
      alert('Täytä kaikki vaaditut kentät.');
      return;
    }

    // Disable button and show progress
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Lähetetään...';
    }
    if (progressContainer) progressContainer.style.display = 'flex';
    updateProgress(0);

    // 1. Upload file to Cloudinary
    uploadFile(file, function(designUrl) {
      console.log('File upload complete. Submitting to Google Sheets...');

      // 2. Submit data to Google Sheets via GET request to avoid CORS preflight
      const params = new URLSearchParams();
      params.append('name', name);
      params.append('email', email);
      params.append('designUrl', designUrl);

      fetch(`${GOOGLE_SCRIPT_URL}?${params.toString()}`, {
        method: 'GET',
        mode: 'no-cors', // Important for this workaround
      })
      .finally(() => {
        // Since we can't read the response in no-cors mode, we assume success
        // because the data does get to the sheet.
        console.log('Submission request sent to Google Sheets.');
        if (progressContainer) progressContainer.style.display = 'none';
        if (form) form.style.display = 'none';
        if (successMessage) successMessage.style.display = 'block';
      });
    });

    return false;
  }

  // --- Initialization ---
  
  // To prevent interference from theme scripts, we clone the form to remove any attached event listeners.
  const originalForm = document.getElementById('designCompetitionForm');
  if (!originalForm) return; // Exit if the form is not on the page

  const newForm = originalForm.cloneNode(true);
  originalForm.parentNode.replaceChild(newForm, originalForm);

  // Now, get references to the elements *within the new form*.
  form = newForm;
  fileInput = form.querySelector('#designFile');
  fileNameDisplay = form.querySelector('.file-name');
  submitBtn = form.querySelector('#submitBtn');
  successMessage = document.getElementById('successMessage'); // This is outside the form
  progressBar = form.querySelector('.progress-bar');
  progressText = form.querySelector('.progress-text');
  progressContainer = form.querySelector('#uploadProgress');

  // Attach event listeners to the new elements
  if (fileInput) {
    fileInput.addEventListener('change', onFileSelected);
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', onFormSubmit);
    submitBtn.disabled = true; // Keep it disabled until a file is chosen
  }

  console.log('Design competition form initialized.');
});
